var map = {
	"./id_alex_aspremont_bw.png": "401b",
	"./id_alex_poinso_bw.png": "c126",
	"./id_antoine_richet_bw.png": "7463",
	"./id_bw.png": "fb65",
	"./id_claire_bonfils_bw.png": "f4a0",
	"./id_frederic_frappart_bw.png": "b460",
	"./id_hui_yang_bw.png": "0449",
	"./id_jp_wigneron_bw.png": "2faf",
	"./id_lei_fan_bw.png": "6bc5",
	"./id_martin_brandt_bw.png": "a37e",
	"./id_philippe_ciais_bw.png": "afd6",
	"./id_rasmus_fensholt_bw.png": "0448",
	"./id_xiangming_xiao_bw.png": "6e98",
	"./id_xiaojun_li_bw.jpg": "0011",
	"./id_yuanwei_qin_bw.png": "8070"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b270";